import { Account } from '@/types';

/**
 * Form data structure for JIRA edit modal.
 * Index signature required for compatibility with SetupModal's Values type.
 */
export interface JiraEditFormData {
  [key: string]: string;
  id: string;
  displayName: string;
  projectKey: string;
  projectName: string;
  issueType: string;
  autoCreate: string;
  severities: string;
}

/**
 * Extracts JIRA template data for editing form.
 *
 * Note: Currently supports editing first template only.
 * If multiple templates exist, only the first is editable via this UI.
 *
 * @param account - The JIRA account integration
 * @returns Form data for SetupModal
 */
export function getJiraEditFormData(account: Account): JiraEditFormData {
  const templates = account.settings?.templates;
  const template =
    Array.isArray(templates) && templates.length > 0 ? templates[0] : undefined;

  return {
    id: template?.id || '',
    displayName: account.settings?.displayName || '',
    projectKey: template?.projectKey || '',
    projectName: template?.projectName || '',
    issueType: template?.issueType || '',
    autoCreate: template?.autoCreate || '',
    severities: template?.severities || 'MHC',
  };
}
